/** @format */

import formReducer from "../features/formSlice";
import tabsReducer from "../features/tabsSlice"
import checkoutReducer from "../features/checkoutSlice"
import { combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
const appReducer = combineReducers({
  FormState: formReducer,
  TabsState: tabsReducer,
  CheckoutState: checkoutReducer,

});
const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE") {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
export default rootReducer;
